<div class="error-wrapper">
  <div class="error">
    <div class="logo__error">
      <img src="assets/images/logo.svg">
    </div>

    <div class="error__inner">
      <div class="icon-wrapper">
        <i class="fal fa-exclamation-circle" style="font-size: 65px;"></i>
      </div>
      <h1>OOPS</h1>
      <p>Looks like you have been inactive for some time now.</p>
      <p><a routerLink="/login" class="error-btn">Sign In</a></p>
    </div>
  </div>
</div>
